import { createReducer, on } from '@ngrx/store';
import {
  failStatus,
  initialStatus,
  loadingStatus,
  successStatus,
} from '@core/models/request-status.model';
import { ProductStore } from '@b2b/features/product/core/utilities/product.model';
import {
  clearProduct,
  getPrice,
  getPriceFail,
  getPriceSuccess,
  getProduct,
  getProductFail,
  getProductSuccess,
  getStock,
  getStockFail,
  getStockSuccess,
} from '@b2b/features/product/core/store/actions/product.actions';

const initialState: ProductStore = {
  product: {
    ...initialStatus,
  },
  price: {
    ...initialStatus,
  },
  stock: {
    ...initialStatus,
  },
};

export const productReducer = createReducer(
  initialState,

  on(clearProduct, (_state: ProductStore): ProductStore => {
    return initialState;
  }),

  on(getProduct, (state: ProductStore): ProductStore => {
    return {
      ...state,
      product: {
        ...state.product,
        ...loadingStatus,
      },
    };
  }),

  on(getProductSuccess, (_state: ProductStore, { data }): ProductStore => {
    return {
      ..._state,
      product: {
        data,
        ...successStatus,
      },
    };
  }),

  on(getProductFail, (_state: ProductStore, data: { erroMessage: string }): ProductStore => {
    return {
      ..._state,
      product: {
        ...initialState,
        ...failStatus,
        message: data.erroMessage,
      },
    };
  }),

  on(getPrice, (state: ProductStore): ProductStore => {
    return {
      ...state,
      price: {
        ...state.price,
        ...loadingStatus,
      },
    };
  }),

  on(getPriceSuccess, (_state: ProductStore, { data }): ProductStore => {
    return {
      ..._state,
      price: {
        data,
        ...successStatus,
      },
    };
  }),

  on(getPriceFail, (_state: ProductStore, data: { erroMessage: string }): ProductStore => {
    return {
      ..._state,
      price: {
        ...initialState,
        ...failStatus,
        message: data.erroMessage,
      },
    };
  }),

  on(getStock, (state: ProductStore): ProductStore => {
    return {
      ...state,
      stock: {
        ...state.stock,
        ...loadingStatus,
      },
    };
  }),

  on(getStockSuccess, (_state: ProductStore, { data }): ProductStore => {
    return {
      ..._state,
      stock: {
        data,
        ...successStatus,
      },
    };
  }),

  on(getStockFail, (_state: ProductStore, data: { erroMessage: string }): ProductStore => {
    return {
      ..._state,
      stock: {
        ...initialState,
        ...failStatus,
        message: data.erroMessage,
      },
    };
  }),
);
